import { Typography, Tooltip, Chip } from "@mui/material";
import { tss } from "tss-react";
import { icons } from "constants/viewer";
import { FoldersActions } from "actions";
import { getFileIcon } from "actions/GlobalActions";
import { Public } from "@mui/icons-material";
import { ReactComponent as File } from "assets/images/file.svg";
import { folderColor, iconColor } from "styles/common";
import { useVersioning } from "constants/common";

const useStyles = tss.create({
    rowBig: {
        cursor: "pointer",
        width: "100%",
        "&:hover": {
            backgroundColor: "#E6E6E6",
        },
        paddingLeft: 10,
    },
    rowSmall: {
        width: 150,
        overflow: "hidden",
    },
    rowContent: {
        width: "100%",
        display: "inline-flex",
        height: 40,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        alignItems: "center"
    },
    labelContainer: {
        width: "100%",
        position: "relative",
        display: "inline-flex",
    },
    chipContainer: {
        width: "100%",
        position: "relative",
        display: "inline-flex",
    },
    label: {
        fontSize: 14,
        overflow: "hidden",
        textOverflow: "ellipsis",
        //width: 200,
    },
    icon: {
        position: "relative",
        verticalAlign: "middle",
        display: "inline-block",
        color: iconColor,
        marginRight: "4px"
    },
    iconLayer: {
        width: 25,
        height: 25,
    },
});

function FileIcon(props: { file: any }) {
    const { classes, cx } = useStyles();
    const { file } = props;

    if (file["type"] === "PROJECT") {
        return <Public className={cx(classes.icon, classes.iconLayer)} />;
    }
    const fileName = getFileIcon(file);
    //console.log("fileName:", fileName);

    const Icon = icons[fileName];
    if (Icon) {
        return <Icon className={cx(classes.icon, classes.iconLayer)} />;
    }

    return <File className={cx(classes.icon, classes.iconLayer)} />;
}

export default function EntityInfo(props: { entity: any }) {
    const { classes } = useStyles();
    const { entity } = props;
    let strPath = FoldersActions.getPathFromEntity(entity);
    let strPathShort = strPath;
    if (strPath && strPath.length > 35) {
        strPath = strPath.substring(0, 30) + "...";
    }
    const workflow = FoldersActions.getWorkflowFromEntity(entity) || null;
    let products = (workflow && workflow["products"] && workflow["products"].join(" - ")) || "/";
    let productsShort = products;
    if (products && products.length > 35) {
        products = products.substring(0, 30) + "...";
    }
    return (
        <div className={classes.rowBig}>
            <div className={classes.rowContent}>
                <div className={[classes.icon].join(" ")}>{<FileIcon file={entity} />}</div>
                <div className={classes.labelContainer}>
                    <Tooltip title={entity.name}>
                        <Typography className={classes.label}>{entity.name}</Typography>
                    </Tooltip>
                </div>
                { useVersioning && (
                    <div className={classes.chipContainer}>
                        {workflow === null ? (
                            <div>
                                <Chip label="Not Versioned" size="small" style={{ marginLeft: 7, minWidth: "100px", height: "22px", fontSize: "12px" }} />
                                <Tooltip title={strPathShort}>
                                    <Chip label={strPath} size="small" style={{ marginLeft: 7/*, width: 300*/ }} />
                                </Tooltip>
                            </div>
                        ) : (
                            <div>
                                <Chip
                                    label={"Version: " + workflow["version"]}
                                    size="small"
                                    style={{ marginLeft: 7, backgroundColor: folderColor, minWidth: "100px", height: "22px", fontSize: "12px",color: "#000" }}
                                />
                                <Tooltip title={products}>
                                    <Chip label={productsShort} size="small" style={{ marginLeft: 7 /*, width: 300*/}} />
                                </Tooltip>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
